import { installasjon } from '../diverse/installasjon';

const SAKSBEHANDLINGS_APP_NAME = 'arbeidsvarsling-saksbehandling';

const finnMiljo = () => {
	const { href } = window.location;
	if (
		href.startsWith('https://www.utv.') ||
		href.startsWith('http://localhost') ||
		href.startsWith(`https://${SAKSBEHANDLINGS_APP_NAME}.utv.`)
	) {
		return 'UTV';
	}
	if (
		href.startsWith('https://www.test.') ||
		href.startsWith(`https://${SAKSBEHANDLINGS_APP_NAME}.test.`)
	) {
		return 'TEST';
	}
	return 'PROD';
};
const apper = [
	'apv-arbeidsvarsling-soknad',
	'apv-arbeidsvarsling-frontendkomponenter',
	'apv-arbeidsvarsling-ekstern',
].join(',');

const oppslagsadresser = [
	(sprak, miljo = 'PROD') =>
		`https://tekstapp.atlas.vegvesen.no/api/apptekst?apper=${apper}&miljo=${miljo}&sprak=${sprak.toUpperCase()}`,
];

export function Ledetekst(mottak) {
	var forsok = oppslagsadresser.length;
	var standardsprak = 'no';
	var valgtSprak = standardsprak;
	var standardtekster = {};
	var valgteTekster = {};
	var tilstand = 'venter';

	function initSprak() {
		valgtSprak =
			(
				decodeURIComponent(window.document.cookie)
					.split(';')
					.filter(function (cookie) {
						cookie = cookie.split(/=/);
						return cookie[0].trim() === 'ForceLocale1';
					})
					.join('') || '='
			)
				.split(/=/)[1]
				.trim() || 'no';
	}

	var over = this;

	function hentTeksterGjentatt(sprak, n) {
		n--;
		return over
			.hentTekster(sprak, oppslagsadresser[forsok - n - 1])
			.catch(function (e) {
				if (n === 0) {
					return {};
				}
				return hentTeksterGjentatt(sprak, n);
			});
	}

	function dekodTekster(tekster) {
		Object.keys(tekster || {}).forEach(function (plassholder) {
			tekster[plassholder] = String(tekster[plassholder]).replace(
				/&#([\d]+);?/g,
				function (treff, kode) {
					return String.fromCharCode(kode);
				}
			);
		});
		return tekster;
	}

	function initTekster(mottak) {
		Promise.all([
			hentTeksterGjentatt(standardsprak, forsok),
			standardsprak === valgtSprak
				? Promise.resolve({})
				: hentTeksterGjentatt(valgtSprak, forsok),
		])
			.then(function (json) {
				standardtekster = dekodTekster(json[0]);
				valgteTekster = dekodTekster(json[1]);
				if (standardtekster === {} && valgteTekster === {}) {
					throw 'Ingen tekster ble funnet.';
				}
				tilstand = 'ferdig';
			})
			.catch(function (e) {
				tilstand = 'feil';
				console.error('Feil ved henting av ledetekster: ', e);
			})
			.then(function () {
				mottak();
			});
	}

	var tilbakekall = [mottak];

	function kallTilbake() {
		tilbakekall
			.filter((mottak) => typeof mottak === 'function')
			.map((mottak) => mottak());
		tilbakekall = [];
	}

	this.avvent = function (mottak) {
		tilbakekall.push(mottak);
		if (tilstand !== 'venter') {
			kallTilbake();
		}
	};

	initSprak();
	this.avvent(mottak);
	initTekster(kallTilbake);

	function velgTekst(plassholder) {
		return (
			valgteTekster[plassholder] ||
			standardtekster[plassholder] ||
			`{${plassholder}}`
		);
	}

	function formaterTekst(tekst, innsatte) {
		if (tekst === '-') {
			return ' ';
		}
		return String(tekst).replace(/{(\d+)}/g, function (treff, nummer) {
			return innsatte[nummer] === undefined ? treff : innsatte[nummer];
		});
	}

	this.getSprak = function () {
		return valgtSprak;
	};

	this.getTekst = function (plassholder) {
		return formaterTekst(
			velgTekst(plassholder),
			Array.prototype.slice.call(arguments, 1)
		);
	};
}

Ledetekst.prototype.hentTekster = (sprak, oppslag) => {
	const miljo = finnMiljo();
	return fetch(oppslag(sprak, miljo), {
		credentials: 'include',
	}).then((res) => {
		if (!res.ok) {
			throw '';
		}
		return res.json();
	});
};

export const ledetekst = new Ledetekst();
